import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { TPopupDefaultActions } from '../../../../../../../../../shared/components/popup/services/popup.service.ts';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPopup } from './content.popup.tsx';
import { map } from 'rxjs';

export class TextPopup extends Popup<ITextPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const Wrapper = useMemo(() => this.Wrapper, []);
      const { t } = useTranslation();
      const [popupTitle, setPopupTitle] = useState('');

      useEffect(() => {
        stream
          .actionListener('open')
          .pipe(map(({ title }) => `${t('settings.text_block')} | ${title}`))
          .subscribe(setPopupTitle);
      }, []);

      return (
        <Wrapper
          stream={stream}
          slotProps={{ paper: { sx: { maxWidth: '748px' } } }}
          fullWidth
          {...{ popupTitle }}
        >
          <ContentPopup {...{ stream }} />
        </Wrapper>
      );
    };
  }
}

export interface ITextPopup {
  action: TPopupDefaultActions;
  id: string;
  title: string;
}
